import { LoggingService } from '@instinet-analytics/core-lib';
import IndigoServiceClient from 'communication/IndigoServiceClient';
import { buildLogger, Logger } from '@instinet-analytics/core-lib';
import { ApiRequestOptions } from 'communication/ApiCallInfo';
import IndigoApiError from 'communication/IndigoApiError';
import { SymbolValidationResponse } from 'symbols/api/SymbolValidationResponse';
import { SymbologyValues } from 'app/store/appSettings/AppSettingsState';
import { SymbolConvertResponse } from 'symbols/api/SymbolConvertResponse';
import { SymbolStaticDataState } from 'symbols/store/symbolStaticDataSlice';

export interface SymbolsApiOptions {
    loggingService: LoggingService;
    indigoServiceClient: IndigoServiceClient;
}

export class SymbolsApi {
    private indigoServiceClient: IndigoServiceClient;
    private logger: Logger;

    public constructor(options: SymbolsApiOptions) {
        this.indigoServiceClient = options.indigoServiceClient;
        this.logger = buildLogger('IndigoApi', options.loggingService);
    }

    public async validateSymbol(
        symbol: string,
        symbology: SymbologyValues,
        options: ApiRequestOptions
    ): Promise<SymbolValidationResponse> {
        const queryParameters = {
            symbol,
            symbology,
            symbolSearch: 'true',
            limit: '200',
        };
        const url = 'symbol/search';

        return await IndigoApiError.runHandlingErrorsAsync(
            `Validate Symbol`,
            async () => {
                return await this.indigoServiceClient.get<SymbolValidationResponse>(
                    url,
                    options,
                    queryParameters
                );
            }
        );
    }

    public async convert(
        symbols: string[],
        fromSymbology: SymbologyValues,
        toSymbology: SymbologyValues,
        options: ApiRequestOptions
    ): Promise<SymbolConvertResponse> {
        const queryParameters = {
            symbols: symbols.join(','),
            fromSymbology,
            toSymbology,
        };
        const url = 'symbol/convert';

        return await IndigoApiError.runHandlingErrorsAsync(
            `Converts Symbol`,
            async () => {
                return await this.indigoServiceClient.get<SymbolConvertResponse>(
                    url,
                    options,
                    queryParameters
                );
            }
        );
    }

    public async getStaticData(
        options: ApiRequestOptions
    ): Promise<SymbolStaticDataState> {
        const url = 'symbol/staticData';

        return await IndigoApiError.runHandlingErrorsAsync(
            `Get Symbol Static Data`,
            async () => {
                return await this.indigoServiceClient.get<SymbolStaticDataState>(
                    url,
                    options
                );
            }
        );
    }
}
